export default __webpack_public_path__ + "beb178a5382128841f3fd77cf099fc0a.svg";